import React from 'react';
import { motion } from 'framer-motion';
export function Differentiator() {
  return <section className="py-24 px-6 bg-brand-600 text-white text-center" data-id="element-43">
      <div className="max-w-3xl mx-auto" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-45">
          <p className="text-brand-200 text-lg md:text-xl font-medium mb-8 tracking-wide uppercase" data-id="element-46">
            La mayoría de las propiedades no se venden mal. Se venden mal
            gestionadas.
          </p>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6 leading-tight" data-id="element-47">
            No somos corredores. <br className="hidden md:block" data-id="element-48" />
            <span className="text-white" data-id="element-49">Tampoco te dejamos solo.</span>
          </h2>
          <p className="text-xl md:text-2xl text-brand-100 font-medium max-w-2xl mx-auto" data-id="element-50">
            Tú haces la venta. Nosotros nos encargamos de que todo funcione
            bien.
          </p>
        </motion.div>
      </div>
    </section>;
}